export const Select = ({ label, id, options = [], ...props }) => (
    <div className="w-full">
        {label && <label htmlFor={id} className="block text-xs font-medium text-slate-500 uppercase tracking-wider mb-1.5">{label}</label>}
        <select
            id={id}
            className="w-full rounded-lg border border-slate-200 bg-white px-3.5 py-2 text-sm text-slate-800 transition-all focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/10"
            {...props}
        >
            {options.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
        </select>
    </div>
);